import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { connect, Provider } from 'react-redux';
import { userActions } from '../actions/userActions';
import { Link } from 'react-router-dom'
import Lang from './Lang'
import logo from './../img/ab_logo4.png';
import {_t} from './../i18n/lang'

class LoginPage extends React.Component {
	constructor(props) {
    	super(props);
    	this.state = {
    		login: '',
    		password: '',
    		submitted: false
    	};

    	this.handleChangeLogin 		= this.handleChangeLogin.bind(this);
    	this.handleChangePassword 	= this.handleChangePassword.bind(this);
    	this.handleSubmit 			= this.handleSubmit.bind(this);
  	}

  	handleChangeLogin(event) {
    	this.setState({login: event.target.value});
  	}

  	handleChangePassword(event) {
    	this.setState({password: event.target.value});
  	}

  	handleSubmit(event) {
    	event.preventDefault();
    	this.setState({submitted:true})
    	const { login, password } = this.state;
			if (login && password) {
					this.props.login(login, password);
			}
  	}

	render() {
		const { alert, isLoading } = this.props;
		const { login, password, submitted } = this.state;

		return <div className="container">
			<div className="row" style={{paddingTop: '50px', background: '#fff'}}>
				<div className="col-md-4 col-lg-4" >
					<h1>Witamy w AB Online!</h1>
					<div className="card">

						<div className="card-body">
							{alert.message &&
                           		<div className={`alert ${alert.type}`}>{alert.message}</div>
                       		}
							<form onSubmit={this.handleSubmit}>
								<div className='form-group'>
									<label htmlFor="loginLoginInput" >Login: </label>
									<input type='text' id='loginLoginInput' value={login} onChange={this.handleChangeLogin} disabled={isLoading} className={'form-control'  + (submitted && !login ? ' is-invalid' : '')}/>
									{submitted && !login &&
                            			<div className="invalid-feedback">Username is required</div>
                        			}
								</div>
								<div className='form-group'>
									<label htmlFor="loginPasswordInput" >Hasło: </label>
									<input type='password' id="loginPasswordInput" value={this.state.password} onChange={this.handleChangePassword} autoComplete="on" disabled={isLoading} className={"form-control"+ (submitted && !password ? ' is-invalid' : '')} />
									{submitted && !password &&
                            			<div className="invalid-feedback">Password is required</div>
                        			}
								</div>
								<button type="submit" className="btn btn-primary float-right " disabled={isLoading}>Zaloguj</button>
							</form>

						</div>
					</div>
					<div style={{padding: '1.25rem'}}>
						<a href="https://rejestracja.ab.pl" style={{fontWeight: 500, display: 'block'}}>Zapomniałem hasła</a>
						<a href="https://rejestracja.ab.pl" style={{fontWeight: 500, display: 'block'}}>Rejestracja</a>
						<a href="https://www.ab.pl/" style={{fontWeight: 500, display: 'block'}}>Strona firmowa AB</a>
					</div>
				</div>
				<div className="col-md-8">
					<img src="https://www.abonline.pl/content/widgetmagic/Przed_logowanie_indo.jpg" />
					<h2 style={{marginTop: '30px'}}>O firmie</h2>
					<div style={{textAlign: 'justify'}}>Potwierdzeniem zaufania, jakim obdarzają nas klienci, jest fakt, że grupa AB jako jedyne polskie przedsiębiorstwo zalicza się do grona 9 największych dystrybutorów IT i dostawców rozwiązań e-commerce w Europie. Z kolei w Polsce i Europie Środkowo-Wschodniej od lat niezmiennie jesteśmy liderem. Do Twojej dyspozycji oddajemy 100 tys. produktów – skorzystaj z możliwości, jakie Ci dajemy i stań się jednym z naszych 16 tys. partnerów handlowych. Należymy do wiodących dostawców usług chmurowych (cloud), e-commerce oraz wartości dodanej w dystrybucji (VAD), a także zajmujemy się dystrybucją sprzętu AGD/RTV i zabawek. Aby spełnić Twoje wymagania, korzystamy z rozbudowanego zaplecza logistycznego, które pozwala nam wciąż powiększać zakres działalności i liczbę partnerów handlowych.

					</div>
					<img src='https://www.ab.pl/wp-content/uploads/2019/02/P1060471.00_00_15_18.Still004-2-1024x749.jpg' style={{maxWidth: '100%', marginTop: '20px'}} />
				</div>
			</div>
			<hr/>
			<Link to='/' style={{float: 'left'}}><img src={ logo } alt="AB Online" /></Link>
			<Lang />
		</div>

	}
}

function mapState(state) {
  const { alert, user } = state
  return { alert: alert, isLoading: user.isLoading }
}



const actionCreators = {
	login: userActions.login,
};

export default connect(mapState, actionCreators)(LoginPage);
